import * as Sentry from '@sentry/react'
import { Roles } from '../models/roles'
import {
  filterAuthFromRedux,
  filterPayApplyFromRedux,
  filterStoreInfoFromRedux,
} from './utils/reduxUtils'

const setUserIdByAuth = auth => {
  const { role, userId, username } = auth || {}
  const userIdToLog = role === Roles.RESURS_ADMIN ? username : userId
  Sentry.setUser({
    ...(userIdToLog && { 'user.id': userIdToLog }),
  })
}

const setDefaultTagsForRedux = ({ storeInfo, payApply }) => {
  const {
    id: representativeId,
    accountSystemChainId,
    chainType,
    name: representativePopularName,
    tradeName: representativeTradeName,
    country: countryCode,
  } = storeInfo.currentRepresentative || {}

  const {
    id: storeId,
    accountSystemStoreId,
    name: storePopularName,
    tradeName: storeTradeName,
  } = storeInfo.currentStore || {}

  const { type: paymentType, status, id: paymentId } = payApply.current || {}

  Sentry.setTags({
    ...(representativeId && { 'representative.id': representativeId }),
    ...(accountSystemChainId && {
      'account_system.chain_id': accountSystemChainId,
    }),
    ...(chainType && { chain_type: chainType }),
    ...(representativePopularName && {
      'representative.popular_name': representativePopularName,
    }),
    ...(representativeTradeName && {
      'representative.trade_name': representativeTradeName,
    }),
    ...(countryCode && { country_code: countryCode }),
    ...(storeId && { 'store.id': storeId }),
    ...(accountSystemStoreId && {
      'account_system.store_id': accountSystemStoreId,
    }),
    ...(storePopularName && { 'store.popular_name': storePopularName }),
    ...(storeTradeName && { 'store.trade_name': storeTradeName }),
    ...(paymentId && { 'payment.id': paymentId }),
    ...(paymentType && { 'payment.type': paymentType }),
    ...(status && { 'payment.status': status }),
  })
}

const configureScopeWithState = () => (scope, state) => {
  setUserIdByAuth(state.auth)
  setDefaultTagsForRedux(state)
  // eslint-disable-next-line no-param-reassign
  scope._breadcrumbs = []
}

export const stateTransformer = () => state => {
  const auth = filterAuthFromRedux(state)
  const storeInfo = filterStoreInfoFromRedux(state)
  const payApply = filterPayApplyFromRedux(state)

  return {
    payApply,
    auth,
    storeInfo,
  }
}

export const configureSentryRedux = () =>
  Sentry.createReduxEnhancer({
    configureScopeWithState: configureScopeWithState(),
    stateTransformer: stateTransformer(),
  })
